import React from "react";
import PropTypes from "prop-types";
import Headline from "~/assets/js/components/Typography/Headline";
import i18n from "~/assets/js/Helpers/i18n";
import MarkdownText from "../Typography/MarkdownText";

const Description = ({ desc }) => {
    return (
        <div id="product-description">
            <Headline size={6} className="title">
                {i18n.t("productInfo.description")}
            </Headline>
            <MarkdownText className="content">{desc}</MarkdownText>
        </div>
    );
};

Description.propTypes = {
    desc: PropTypes.string,
};

export default Description;
